
import {Monitor} from './js/common/js-sdk-perf.esm.min.js';

new Monitor().init({
	id: "Jyy3ZiYIVUGkPqpv", sendSpaPv: true,
});

